import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import AuthModal from './AuthModal'

const NAV_ITEMS = [
  { path: '/', label: 'Dashboard' },
  { path: '/predict', label: 'Predict' },
  { path: '/leaderboard', label: 'Leaderboard' },
  { path: '/stats', label: 'My Stats' },
]

export default function Layout({ children }) {
  const { user, signOut } = useAuth()
  const { pathname } = useLocation()
  const [showAuth, setShowAuth] = useState(false)

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bg)' }}>
      <style>{`
        .bottom-nav { display: none; }
        .desktop-nav { display: flex; }
        .header-auth { display: flex; }

        @media (max-width: 600px) {
          .bottom-nav {
            display: flex;
            position: fixed;
            bottom: 0; left: 0; right: 0;
            height: 52px;
            background: var(--surface);
            border-top: 1px solid var(--border);
            z-index: 200;
            padding-bottom: env(safe-area-inset-bottom);
            gap: 6px;
            padding: 6px 8px;
            padding-bottom: calc(6px + env(safe-area-inset-bottom));
          }
          .bottom-nav a {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            font-family: var(--sans);
            font-size: 11px;
            font-weight: 500;
            color: var(--text3);
            transition: all 0.15s;
            border: 1px solid var(--border);
            border-radius: 4px;
            background: var(--surface2);
          }
          .bottom-nav a.active {
            color: var(--olive);
            border-color: var(--olive-dim);
            background: var(--olive-bg2);
            font-weight: 600;
          }
          .desktop-nav { display: none; }
          .header-auth { display: flex; }
          .main-content { padding-bottom: 70px !important; }
          .site-footer { padding-bottom: calc(20px + 58px + env(safe-area-inset-bottom)) !important; }
          .main-pad { padding: 16px 12px !important; }
          .header-inner { padding: 0 12px !important; }
        }
      `}</style>

      {/* Header */}
      <header style={{
        background: 'var(--surface)', borderBottom: '2px solid var(--olive)',
        position: 'sticky', top: 0, zIndex: 100,
      }}>
        <div className="header-inner" style={{
          maxWidth: 1200, margin: '0 auto', padding: '0 32px', height: 56,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
        }}>
          <Link to="/" style={{ textDecoration: 'none', flexShrink: 0 }}>
            <span style={{ fontFamily: 'var(--display)', fontSize: 18, fontWeight: 700, color: 'var(--olive)', letterSpacing: '-0.3px' }}>
              EarningsEdge
            </span>
          </Link>

          {/* Desktop nav — hidden on mobile */}
          <nav className="desktop-nav" style={{ gap: 2 }}>
            {NAV_ITEMS.map(({ path, label }) => (
              <Link key={path} to={path} style={{
                padding: '6px 12px', borderRadius: 4, fontSize: 13, fontWeight: 500,
                textDecoration: 'none', whiteSpace: 'nowrap',
                color: pathname === path ? 'var(--olive)' : 'var(--text2)',
                background: pathname === path ? 'var(--olive-bg2)' : 'transparent',
                borderBottom: pathname === path ? '2px solid var(--olive)' : '2px solid transparent',
                transition: 'all 0.15s',
              }}>{label}</Link>
            ))}
          </nav>

          {/* Auth — shown on both mobile and desktop */}
          <div className="header-auth" style={{ flexShrink: 0, alignItems: 'center', gap: 8 }}>
            {user ? (
              <>
                <span style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'var(--mono)' }}
                  className="desktop-only">
                  {user.email?.split('@')[0]}
                </span>
                <button onClick={signOut} style={{
                  background: 'transparent', border: '1px solid var(--border2)',
                  color: 'var(--text2)', padding: '5px 10px', borderRadius: 4,
                  fontSize: 12, cursor: 'pointer', fontFamily: 'var(--sans)',
                }}>Sign out</button>
              </>
            ) : (
              <button onClick={() => setShowAuth(true)} style={{
                background: 'var(--olive)', border: 'none', color: '#fff',
                padding: '6px 14px', borderRadius: 4, fontSize: 13, fontWeight: 600,
                cursor: 'pointer', fontFamily: 'var(--sans)', whiteSpace: 'nowrap',
              }}>Sign in</button>
            )}
          </div>
        </div>
      </header>

      <main className="main-pad main-content" style={{ flex: 1, maxWidth: 1200, margin: '0 auto', width: '100%', padding: '32px 32px' }}>
        {children}
      </main>

      <footer style={{ borderTop: '1px solid var(--border)', padding: '20px 16px', background: 'var(--surface)', marginBottom: 0 }} className="site-footer">
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <div style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'var(--mono)', letterSpacing: '0.5px' }}>
            EARNINGSEDGE · DATA VIA NASDAQ, FINNHUB &amp; YAHOO FINANCE · NOT FINANCIAL ADVICE
          </div>
          <div style={{ display: 'flex', gap: 20 }}>
            {[
              { path: '/about', label: 'About' },
              { path: '/privacy', label: 'Privacy Policy' },
              { path: '/terms', label: 'Terms of Service' },
            ].map(({ path, label }) => (
              <Link key={path} to={path} style={{
                fontSize: 12, color: 'var(--text3)', textDecoration: 'none', fontFamily: 'var(--sans)',
              }}>{label}</Link>
            ))}
          </div>
        </div>
      </footer>

      {/* Bottom tab bar — mobile only */}
      <nav className="bottom-nav">
        {NAV_ITEMS.map(({ path, label, icon }) => (
          <Link key={path} to={path} className={pathname === path ? 'active' : ''}>
            {label}
          </Link>
        ))}
      </nav>

      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </div>
  )
}
